/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import Vue from 'vue';
import Quasar from 'quasar/src/vue-plugin.js';import QLayout from 'quasar/src/components/layout/QLayout.js';import QHeader from 'quasar/src/components/header/QHeader.js';import QDrawer from 'quasar/src/components/drawer/QDrawer.js';import QPageContainer from 'quasar/src/components/page/QPageContainer.js';import QPage from 'quasar/src/components/page/QPage.js';import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QList from 'quasar/src/components/item/QList.js';import QItem from 'quasar/src/components/item/QItem.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';import QMenu from 'quasar/src/components/menu/QMenu.js';import Ripple from 'quasar/src/directives/Ripple.js';import Notify from 'quasar/src/plugins/Notify.js';;
Vue.use(Quasar, {
  config: {},
  components: {
    QLayout: QLayout,
    QHeader: QHeader,
    QDrawer: QDrawer,
    QPageContainer: QPageContainer,
    QPage: QPage,
    QToolbar: QToolbar,
    QToolbarTitle: QToolbarTitle,
    QBtn: QBtn,
    QIcon: QIcon,
    QList: QList,
    QItem: QItem,
    QItemSection: QItemSection,
    QItemLabel: QItemLabel,
    QSlideTransition: QSlideTransition,
    QMenu: QMenu
  },
  directives: {
    Ripple: Ripple
  },
  plugins: {
    Notify: Notify
  }
});